module.exports = require('./isEqual');